import { render } from "./Assemblies.vue?vue&type=template&id=14d89aa8"
import script from "./Assemblies.vue?vue&type=script&lang=js"
export * from "./Assemblies.vue?vue&type=script&lang=js"
script.render = render

export default script